import React from 'react';
import { Card } from 'antd';
import { InfoCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import { formatDateTime } from '../../../../utils/functions';

const EnhancedActivityLogDetails = ({ data }) => {
    if (!data) return null;

    return (
        <div className="sm:!p-6 p-2 bg-gray-50 min-h-full">
            <Card className="shadow-sm mb-6" bordered={false}>
                <h3 className="text-base font-semibold text-gray-700 mb-4 border-b pb-2 flex items-center gap-2">
                    <InfoCircleOutlined />
                    Log Details
                </h3>

                <div className="space-y-4">
                    <div className="p-3 bg-white border border-gray-100 rounded-md">
                        <p className="text-sm text-gray-500 mb-1">Description</p>
                        <p className="text-base font-medium text-gray-800">
                            {data.description || "-"}
                        </p>
                    </div>

                    <div className="p-3 bg-white border border-gray-100 rounded-md">
                        <p className="text-sm text-gray-500 mb-1 flex items-center gap-1">
                            <CalendarOutlined />
                            Occurred At
                        </p>
                        <p className="text-base font-medium text-gray-800">
                            {formatDateTime(data.dateAsPerUserTimezone)}
                        </p>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default EnhancedActivityLogDetails;
